<template>
	<div class="listener-create-container">
		<div class="create-host">
			<div class="jc-page-header">
				<div class="jc-container">
					<el-page-header show-back-icon
						:title="this.type === 'create' ? $t('slb.text.createListener') : $t('slb.text.editListener')"
						@back="jumpToUp()" class="relative">
					</el-page-header>
				</div>
			</div>
			<div class="jc-page-content">
				<div class="jc-container" style="position:relative;">
					<div class="infoBox">
						<el-form class="jc-form listener-create-form" label-width="190px" :model="ruleForm" :rules="rules"
							ref="ruleForm">
							<!-- 基本配置 -->
							<div class="jc-page-card" id="baseConfig">
								<div class="jc-page-card-header" ref="sectionHeader">
									<h3 class="jc-page-card-title">
										{{ $t('slb.text.baseConfig') }}
									</h3>
								</div>
								<div class="jc-page-card-content">
									<!--名称-->
									<el-form-item :label="$t('slb.text.name') | withColon" prop="name" ref="name"
										:show-message="false">
										<el-input v-model="ruleForm.name" class="w500"
											@blur="ruleFormTag.name = ValidOrErrorConstant.NONE"
											@focus="ruleFormTag.name = ValidOrErrorConstant.VALID">
										</el-input>
										<p v-if="ruleFormTag.name !== ValidOrErrorConstant.VALID &&
											ruleForm.name === ''" class="el-form-item-help-error">{{ $t('create.placeholder.nameNull') }}
										</p>
										<p v-else class="el-form-item-help"
											:class="{ 'el-form-item-help-error': this.ruleFormTag.name == 'error' }">
											{{ $t('detail.speechCraft.editNameRule') }}</p>
									</el-form-item>
									<!--监听协议及端口-->
									<el-form-item :label="$t('slb.text.protocolAndPort') | withColon" required
										class="protocol-and-port">
										<!--监听协议-->
										<el-col :span="3">
											<el-form-item prop="protocol">
												<el-select v-model="ruleForm.protocol" @change="changeProtocol"
													:disabled="type === 'edit'">
													<el-option v-for="item in protocols" :key="item.val" :label="item.label"
														:value="item.value">
													</el-option>
												</el-select>
											</el-form-item>
										</el-col>
										<el-col class="line" :span="1" style="margin-left:5px">-</el-col>
										<el-col :span="7">
											<!--端口-->
											<el-form-item prop="port" ref="port" :show-message="false">
												<el-input v-model="ruleForm.port" class="jc-input__inner"
													:class="{ 'input-disabled': type === 'edit' }" @blur="validatePort"
													:disabled="type === 'edit'" ref="port-input"
													@focus="focusPort"></el-input>
											</el-form-item>
											<p class="el-form-item-help" v-if="ruleFormTag.port === ValidOrErrorConstant.ERROR &&
												ruleFormTag.portPart1 !== ValidOrErrorConstant.ERROR &&
												ruleFormTag.portPart2 !== ValidOrErrorConstant.ERROR" :class="{
		'el-form-item-help-error':
			ruleFormTag.port === ValidOrErrorConstant.ERROR
	}">
												{{ $t('slb.sentence.port') }}
											</p>
											<p class="el-form-item-help"
												v-if="ruleFormTag.portPart1 === ValidOrErrorConstant.ERROR" :class="{
													'el-form-item-help-error':
														ruleFormTag.portPart1 === ValidOrErrorConstant.ERROR
												}">
												{{ $t('slb.sentence.portPart1') }}
											</p>
											<p class="el-form-item-help"
												v-if="ruleFormTag.portPart2 === ValidOrErrorConstant.ERROR" :class="{
													'el-form-item-help-error':
														ruleFormTag.portPart2 === ValidOrErrorConstant.ERROR
												}">
												{{ $t('slb.sentence.portPart2') }}
											</p>
										</el-col>
										<el-tooltip style="margin-left:10px" effect="dark" placement="right">
											<div slot="content" class="my-listener-tip">
												{{ $t('slb.sentence.protocolAndPort') }}
											</div>
											<a><i class="jc-icon-question"></i></a>
										</el-tooltip>
									</el-form-item>
									<!--会话保持-->
									<el-form-item :label="$t('slb.text.stickySession') | withColon" prop="stickySession"
										ref="stickySession">
										<el-radio-group v-model="ruleForm.stickySession" size="small"
											@change="changeStickySession">
											<el-radio :label="item.value" v-for="item in onOrOff">{{ item.label }}
											</el-radio>
										</el-radio-group>
										<el-tooltip style="margin-left:10px" effect="dark" placement="right">
											<div slot="content" class="my-listener-tip">
												{{ $t('slb.sentence.stickySession') }}
											</div>
											<a><i class="jc-icon-question"></i></a>
										</el-tooltip>
									</el-form-item>
									<!--会话保持超时-->
									<el-form-item v-if="ifStickySessionTimeout"
										:label="$t('slb.text.stickySessionTimeout') | withColon" :show-message="false"
										prop="stickySessionTimeout" ref="stickySessionTimeout">
										<el-input v-model="ruleForm.stickySessionTimeout" class="w200"
											@input.native="repairInputValue" @blur="blurStickySessionTimeout"
											@focus="foucsStickySessionTimeout" />
										<span class="seconds-time-unit">(s)</span>
										<el-tooltip class="ml10" effect="dark" placement="right">
											<div slot="content" class="my-listener-tip">
												{{ $t('slb.tooltip.stickySessionTimeout') }}
											</div>
											<a><i class="jc-icon-question"></i></a>
										</el-tooltip>
										<p class="el-form-item-help" :class="{
											'el-form-item-help-error': this.ruleFormTag.stickySessionTimeout ===
												ValidOrErrorConstant.ERROR
										}">
											{{ $t('slb.sentence.stickySessionTimeout') }}
										</p>
									</el-form-item>
									<!--会话类型-->
									<el-form-item v-if="ifStickySessionTimeout"
										:label="$t('slb.text.sessionType') | withColon">
										<el-select v-model="ruleForm.cookieType" class="w200">
											<el-option v-for="item in cookieTypes" :key="item.val" :label="item.label"
												:value="item.value">
											</el-option>
										</el-select>
									</el-form-item>
									<!--调度算法-->
									<el-form-item :label="$t('slb.text.algorithm') | withColon" prop="algorithm"
										ref="algorithm" class="protocol-and-port">
										<el-select v-model="ruleForm.algorithm" class="w200">
											<el-option v-for="item in algorithms" :key="item.val" :label="item.label"
												:value="item.value">
											</el-option>
										</el-select>
										<el-tooltip style="margin-left:10px" effect="dark" placement="right">
											<template v-if="ifCurrentProtocol7Lb" slot="content">
												<div class="my-listener-tip" v-if="ruleForm.stickySession === 'on'">
													<b>{{ $t('slb.text.roundRobin') | withColon }}</b>
													{{ $t('slb.sentence.roundRobin') }}
													<br>
												</div>
												<div v-else class="my-listener-tip">
													<b>{{ $t('slb.text.roundRobin') | withColon }}</b>
													{{ $t('slb.sentence.roundRobin') }}
													<br>
													<b>{{ $t('slb.text.leastConnections') | withColon }}</b>
													{{ $t('slb.sentence.leastConnections') }}
													<br>
													<b>{{ $t('slb.text.ipHash') | withColon }}</b>
													{{ $t('slb.sentence.ipHash') }}
												</div>
											</template>
											<template v-else slot="content">
												<div class="my-listener-tip" v-if="ruleForm.stickySession === 'on'">
													<b>{{ $t('slb.text.conhash') | withColon }}</b>
													{{ $t('slb.sentence.conhash') }}
												</div>
												<div class="my-listener-tip" v-else>
													<b>{{ $t('slb.text.roundRobin') | withColon }}</b>
													{{ $t('slb.sentence.roundRobin') }}
													<br>
													<b>{{ $t('slb.text.leastConnections') | withColon }}</b>
													{{ $t('slb.sentence.leastConnections') }}
												</div>
											</template>
											<a><i class="jc-icon-question"></i></a>
										</el-tooltip>
									</el-form-item>
									<!--HTTP2.0-->
									<el-form-item v-if="ifCurrentProtocolHttps" :label="$t('slb.text.http2') | withColon"
										prop="http2" ref="http2">
										<el-radio-group v-model="ruleForm.http2">
											<el-radio v-for="item in onOrOff" :label="item.value">{{ item.label }}
											</el-radio>
										</el-radio-group>
									</el-form-item>
									<!--获取真实IP-->
									<el-form-item v-if="!ifCurrentProtocolUdp" :label="$t('slb.text.realIp') | withColon"
										prop="realIp" ref="realIp">
										<el-radio-group v-model="ruleForm.realIp">
											<el-radio v-for="item in onOrOff"
												:disabled="(ruleForm.protocol === 'https' || ruleForm.protocol === 'http') && item.value === 'off'"
												:label="item.value">{{ item.label }}
											</el-radio>
										</el-radio-group>
										<el-tooltip style="margin-left:10px" effect="dark" placement="right">
											<div slot="content" class="my-listener-tip">
												{{ $t('slb.sentence.realIp') }}
												<a :href="Config.REAP_IP_URL" target="_blank">
													{{ $t('detail.text.operationsGuide') }}</a>
											</div>
											<a><i class="jc-icon-question"></i></a>
										</el-tooltip>
									</el-form-item>
									<!--获取HTTP头字段-->
									<el-form-item v-if="ifCurrentProtocol7Lb"
										:label="$t('slb.text.httpHeader') | withColon">
										<el-checkbox-group v-model="ruleForm.headers">
											<template v-for="item in httpHeaders">
												<el-checkbox :label="item.value">{{ item.label }}</el-checkbox>
												<el-tooltip class="http-tooltip" effect="dark" placement="right">
													<div slot="content" class="my-listener-tip">
														{{ item.tip }}
													</div>
													<a><i class="jc-icon-question"></i></a>
												</el-tooltip>
											</template>
										</el-checkbox-group>
									</el-form-item>
									<!--域名-->
									<el-form-item v-if="ifCurrentProtocolHttps" :label="$t('slb.text.domain') | withColon"
										prop="domain" ref="domain" :show-message="false" required>
										<el-input v-model="ruleForm.domain" class="w200" ref="domain-input"
											@focus="focusDomain"></el-input>
										<p class="el-form-item-help el-form-item-help-error"
											v-if="ruleFormTag.emptyDomain === ValidOrErrorConstant.ERROR">
											{{ $t('slb.sentence.forbiddenEmportyDomain') }}
										</p>
										<p class="el-form-item-help el-form-item-help-error"
											v-if="ruleFormTag.errorDomain === ValidOrErrorConstant.ERROR">
											{{ $t('slb.sentence.domainNotStandardTip') }}
										</p>
									</el-form-item>
									<!-- 证书 -->
									<el-form-item v-if="ifCurrentProtocolHttps"
										:label="$t('slb.text.certificate') | withColon" prop="certificateId" required>
										<el-select v-model="ruleForm.certificateId" class="w200" @change="changeCertificate"
											@visible-change="getCertificates"
											:placeholder="$t('slb.sentence.chooseCertificate')">
											<el-option v-for="item in certificates" :label="item.name" :value="item.certId">
											</el-option>
										</el-select>
										<el-button type="text" @click="openCertificateCreate">
											{{ $t('slb.text.createCertificate') }}
										</el-button>
									</el-form-item>
								</div>
							</div>
							<!-- 健康检查 -->
							<div class="jc-page-card" id="healthCheck">
								<div class="jc-page-card-header">
									<h3 class="jc-page-card-title">{{ $t('slb.text.healthCheck') }}</h3>
								</div>
								<div class="jc-page-card-content">
									<!--健康检查-->
									<el-form-item :label="$t('slb.text.healthCheck') | withColon" prop="healthCheck">
										<el-radio-group v-model="ruleForm.healthCheck" @change="changeHealthCheck">
											<el-radio :label="item.value" v-for="item in onOrOff">{{ item.label }}
											</el-radio>
										</el-radio-group>
									</el-form-item>
									<!--响应超时时间-->
									<el-form-item :label="$t('slb.text.healthCheckTimeout') | withColon"
										prop="healthCheckTimeout" ref="healthCheckTimeout" :show-message="false"
										v-if="isHealthCheckOn">
										<el-input v-model="ruleForm.healthCheckTimeout" class="w200 jc-input__inner"
											maxlength="2" @blur="validateHealthCheckTimeout"
											@focus="focusHealthCheckTimeout"></el-input>
										<span class="seconds-time-unit">(s)</span>
										<el-tooltip style="margin-left:10px" effect="dark" placement="right">
											<div slot="content" class="my-listener-tip">
												{{ $t('slb.tooltip.healthCheckTimeout') }}
											</div>
											<a><i class="jc-icon-question"></i></a>
										</el-tooltip>
										<p class="el-form-item-help" v-if="this.ruleFormTag.healthCheckTimeout !==
											ValidOrErrorConstant.ERROR">
											{{ $t('slb.sentence.healthCheckTimeout') }}
										</p>
										<p class="el-form-item-help" v-if="this.ruleFormTag.healthCheckTimeoutPart1 ===
											ValidOrErrorConstant.ERROR" :class="{
		'el-form-item-help-error': this.ruleFormTag.healthCheckTimeout ===
			ValidOrErrorConstant.ERROR
	}">
											{{ $t('slb.sentence.healthCheckTimeoutPart1') }}
										</p>
										<p class="el-form-item-help" v-if="this.ruleFormTag.healthCheckTimeoutPart2 ===
											ValidOrErrorConstant.ERROR" :class="{
		'el-form-item-help-error': this.ruleFormTag.healthCheckTimeout ===
			ValidOrErrorConstant.ERROR
	}">
											{{ $t('slb.sentence.healthCheckTimeoutPart2') }}
										</p>
									</el-form-item>
									<!--健康检查间隔-->
									<el-form-item :label="$t('slb.text.healthCheckInterval') | withColon"
										prop="healthCheckInterval" ref="healthCheckInterval" :show-message="false"
										v-if="isHealthCheckOn">
										<el-input v-model="ruleForm.healthCheckInterval" class="w200 jc-input__inner"
											maxlength="3" @blur="validateHealthCheckInterval"
											@focus="focusHealthCheckInterval"></el-input>
										<span class="seconds-time-unit">(s)</span>
										<el-tooltip style="margin-left:10px" effect="dark" placement="right">
											<div slot="content" class="my-listener-tip">
												{{ $t('slb.tooltip.healthCheckInterval') }}
											</div>
											<a><i class="jc-icon-question"></i></a>
										</el-tooltip>
										<p class="el-form-item-help" v-if="this.ruleFormTag.healthCheckInterval !==
											ValidOrErrorConstant.ERROR">
											{{ $t('slb.sentence.healthCheckInterval') }}
										</p>
										<p class="el-form-item-help" v-if="this.ruleFormTag.healthCheckIntervalPart1 ===
											ValidOrErrorConstant.ERROR" :class="{
		'el-form-item-help-error': this.ruleFormTag.healthCheckIntervalPart1 ===
			ValidOrErrorConstant.ERROR
	}">
											{{ $t('slb.sentence.healthCheckIntervalPart1') }}
										</p>
										<p class="el-form-item-help" v-if="this.ruleFormTag.healthCheckIntervalPart2 ===
											ValidOrErrorConstant.ERROR" :class="{
		'el-form-item-help-error': this.ruleFormTag.healthCheckIntervalPart2 ===
			ValidOrErrorConstant.ERROR
	}">
											{{ $t('slb.sentence.healthCheckIntervalPart2') }}
										</p>
									</el-form-item>
									<!--健康阈值-->
									<el-form-item :label="$t('slb.text.healthCheckThreshold') | withColon"
										prop="healthyThreshold" ref="healthyThreshold" :show-message="false"
										v-if="isHealthCheckOn">
										<el-input v-model="ruleForm.healthyThreshold" class="w200 jc-input__inner"
											maxlength="3" @blur="validateHealthyThreshold"
											@focus="ruleFormTag.healthyThreshold = ValidOrErrorConstant.VALID"></el-input>
										<span class="seconds-time-unit">{{ $t('slb.text.timeCount') |
											formatWithParentheses }}</span>
										<el-tooltip style="margin-left:10px" effect="dark" placement="right">
											<div slot="content" class="my-listener-tip">
												{{ $t('slb.tooltip.healthyThreshold') }}
											</div>
											<a><i class="jc-icon-question"></i></a>
										</el-tooltip>
										<p class="el-form-item-help" :class="{
											'el-form-item-help-error': this.ruleFormTag.healthyThreshold ===
												ValidOrErrorConstant.ERROR
										}">
											{{ $t('slb.sentence.healthyThreshold') }}
										</p>
									</el-form-item>
									<!--不健康阈值-->
									<el-form-item :label="$t('slb.text.unhealthyCheckThreshold') | withColon"
										prop="unhealthyThreshold" ref="unhealthyThreshold" :show-message="false"
										v-if="isHealthCheckOn">
										<el-input v-model="ruleForm.unhealthyThreshold" class="w200 jc-input__inner"
											maxlength="3" @blur="validateUnhealthyThreshold"
											@focus="ruleFormTag.unhealthyThreshold = ValidOrErrorConstant.VALID"></el-input>
										<span class="seconds-time-unit">{{ $t('slb.text.timeCount') |
											formatWithParentheses }}</span>
										<el-tooltip style="margin-left:10px" effect="dark" placement="right">
											<div slot="content" class="my-listener-tip">
												{{ $t('slb.tooltip.unhealthyThreshold') }}
											</div>
											<a><i class="jc-icon-question"></i></a>
										</el-tooltip>
										<p class="el-form-item-help" :class="{
											'el-form-item-help-error': this.ruleFormTag.unhealthyThreshold ===
												ValidOrErrorConstant.ERROR
										}">
											{{ $t('slb.sentence.unhealthyThreshold') }}
										</p>
									</el-form-item>
									<!--检查路径-->
									<el-form-item v-if="ifCurrentProtocol7Lb && isHealthCheckOn"
										:label="$t('slb.text.healthCheckUri') | withColon" prop="healthCheckUri"
										ref="healthCheckUri" :show-message="false">
										<el-input v-model="ruleForm.healthCheckUri" class="w200">
										</el-input>
										<el-tooltip class="ml10" effect="dark" placement="right">
											<div slot="content" class="my-listener-tip">
												{{ $t('slb.tooltip.healthCheckUri') }}
											</div>
											<a><i class="jc-icon-question"></i></a>
										</el-tooltip>
									</el-form-item>
									<!--正常态码-->
									<el-form-item v-if="ifCurrentProtocol7Lb && isHealthCheckOn"
										:label="$t('slb.text.healthCheckHttpCode') | withColon" prop="healthCheckHttpCode"
										ref="healthCheckHttpCode" :show-message="false">
										<el-input v-model="ruleForm.healthCheckHttpCode" class="w200">
										</el-input>
										<el-tooltip class="ml10" effect="dark" placement="right">
											<div slot="content" class="my-listener-tip">
												{{ $t('slb.tooltip.healthCheckHttpCode') }}
											</div>
											<a><i class="jc-icon-question"></i></a>
										</el-tooltip>
									</el-form-item>
									<!--健康检查IP-->
									<el-form-item :label="$t('slb.text.healthCheckIp') | withColon" v-if="isHealthCheckOn">
										<span>{{ defaultHealthCheckIp }}</span>
									</el-form-item>
								</div>
							</div>
							<!-- 后端服务器 -->
							<div class="jc-page-card" id="backendServer">
								<div class="jc-page-card-header">
									<h3 class="jc-page-card-title">{{ $t('slb.text.backendServer') }}</h3>
								</div>
								<div class="jc-page-card-content">
									<!--选择服务器组-->
									<el-form-item :label="$t('slb.text.chooseBackendGroup') | withColon" prop="healthCheck"
										required>
										<el-select v-model="serverGroupId" class="w200"
											:no-data-text="$t('speechCraft.listNoText')" @visible-change="getServerGroup">
											<el-option v-for="item in serverGroups" :key="item.val" :label="item.label"
												:value="item.value">
											</el-option>
										</el-select>
										<a href="javascript:void(0)" @click="jumpToSlbDetailDefaultServerGroupTab"
											class="seconds-time-unit">
											{{ $t('slb.text.addServerGroup') }}
										</a>
										<server-group :region="region" :server-group-id="serverGroupId"
											type="create"></server-group>
									</el-form-item>
								</div>
							</div>
						</el-form>
					</div>
				</div>
				<hr class="listener-page-hr">
				<div class="listener-page-footer">
					<el-button @click="jumpToSlbDetailListenerTab">{{ $t('create.text.cancel') }}</el-button>
					<el-button type="primary" @click="confirm" :disabled="isConfirmDisabled">
						{{ $t('create.text.confirm') }}
					</el-button>
				</div>
			</div>
		</div>
		<!-- 创建证书 -->
		<create-cert :visible.sync="createCertVisible" :region="region">
		</create-cert>
	</div>
</template>


<script>
import * as Reg from "@/common/reg";
import ServerGroup from '@/components/slb/detail/ServerGroup'
import createCert from '@/components/slb/createCert';
import {
	CreateTypeConstant,
	NetworkTypeConstant,
	ValidOrErrorConstant,
	BackendServerConstant,
	ProtocolMapConstant
} from '@/common/Constants';
import * as BM from "@/common/bare-metal";
// 校验监听器名称是否符合规范
const validateName = (rule, value, callback) => {
	const reg = new RegExp('^[-0-9a-zA-Z_\\u4e00-\\u9fa5]{1,32}$');
	if (!reg.test(value)) {
		callback(new Error());
	} else {
		callback();
	}
};

// 校验健康阈值是否在指定范围内
const validateHealthyThreshold = (rule, value, callback) => {
	if (value > 10 || value < 1) {
		callback(new Error());
	} else {
		callback();
	}
}

// 校验不健康阈值是否在指定范围内
const validateUnhealthyThreshold = (rule, value, callback) => {
	if (value > 10 || value < 1) {
		callback(new Error());
	} else {
		callback();
	}
}

export default {
	components: {
		ServerGroup,
		createCert
	},
	data() {
		// 校验端口是否在指定范围内
		const validatePort = (rule, value, callback) => {
			if (value > 65535 || value < 1 || this.listenerPortRepeated === true) {
				callback(new Error());
			} else {
				callback();
			}
		}
		// 校验域名是否符合规则
		const validateDomain = (rule, value, callback) => {
			if (!value && this.ifCurrentProtocolHttps) {
				this.ruleFormTag.emptyDomain = ValidOrErrorConstant.ERROR;
				callback(new Error());
			} else if (value && this.ifCurrentProtocolHttps) {
				this.ruleFormTag.emptyDomain = ValidOrErrorConstant.VALID;
				let isValidDomain = Reg.domain.test(value) || Reg.wildcardDomain.test(value);
				if (isValidDomain) {
					this.ruleFormTag.errorDomain = ValidOrErrorConstant.VALID;
					callback();
				} else {
					this.ruleFormTag.errorDomain = ValidOrErrorConstant.ERROR;
					callback(new Error());
				}
			} else {
				this.ruleFormTag.emptyDomain = ValidOrErrorConstant.VALID;
				callback();
			}
		};
		// 校验证书是否选择
		const validateCertificateId = (rule, value, callback) => {
			if (!value && this.ruleForm.protocol === 'https') {
				this.ruleFormTag.certificateId = ValidOrErrorConstant.ERROR;
				callback(new Error(this.$t('create.placeholder.certificateNull')));
			} else {
				this.ruleFormTag.certificateId = ValidOrErrorConstant.VALID;
				callback();
			}
		}
		// 校验会话超时是否符合规范
		const validateStickySessionTimeout = (rule, value, callback) => {
			if (!value || value > 3600 || value < 30) {
				this.ruleFormTag.stickySessionTimeout = ValidOrErrorConstant.ERROR
				callback(new Error())
			} else {
				callback()
			}
		};
		// 校验响应超时时间是否在指定范围内
		const validateHealthCheckTimeout = (rule, value, callback) => {
			if (value > 60 || value < 2 || value > parseInt(this.ruleForm.healthCheckInterval)) {
				callback(new Error());
			} else {
				callback();
			}
		}

		// 校验健康检查间隔是否在指定范围内
		const validateHealthCheckInterval = (rule, value, callback) => {
			if (value > 300 || value < 5
				|| value > parseInt(this.ruleForm.validateHealthCheckTimeout)) {
				callback(new Error());
			} else {
				callback();
			}
		}

		const validateHealthCheckUri = (rule, value, callback) => {
			let regHealthCheckUri = /^\/(\d|\w|\.|%|\?|#|&|=|\/)*$/g;
			if (regHealthCheckUri.test(value) && value.length <= 100) {
				callback();
			} else {
				this.ruleFormTag.healthCheckUri = ValidOrErrorConstant.ERROR
				callback(new Error());
			}
		}

		const validateHealthCheckHttpCode = (rule, value, callback) => {
			let regHealthCheckHttpCode = /^([2-4]xx,)*[2-4]xx$/;
			if (regHealthCheckHttpCode.test(value) || !value.trim()) {
				callback();
			} else {
				callback(new Error());
			}
		};
		const get7LbAlgorithms = (stickySession) => {
			if (stickySession === 'on') {
				return [
					{
						label: this.$t('slb.text.roundRobin'),
						value: 'wrr'
					}
				]
			} else {
				return [
					{
						label: this.$t('slb.text.roundRobin'),
						value: 'wrr'
					},
					{
						label: this.$t('slb.text.leastConnections'),
						value: 'wlc'
					},
					{
						label: this.$t('slb.text.ipHash'),
						value: 'iphash'
					}
				]
			}
		};
		const get4LbAlgorithms = (stickySession) => {
			if (stickySession === 'on') {
				return [
					{
						label: this.$t('slb.text.conhash'),
						value: 'conhash'
					},
				]
			} else {
				return [
					{
						label: this.$t('slb.text.roundRobin'),
						value: 'wrr'
					},
					{
						label: this.$t('slb.text.leastConnections'),
						value: 'wlc'
					}
				]
			}
		};
		const getAlgorithms = {
			'http': (stickySession) => {
				return get7LbAlgorithms(stickySession)
			},

			'https': (stickySession) => {
				return get7LbAlgorithms(stickySession)
			},

			'udp': (stickySession) => {
				return get4LbAlgorithms(stickySession)
			},

			'tcp': (stickySession) => {
				return get4LbAlgorithms(stickySession)
			}
		};
		return {
			getAlgorithms: getAlgorithms,
			clientToken: Normal.getClientToken(),
			// 区域
			region: '',
			createCertVisible: false,
			// 页面参数选择
			regions: {},
			loadBalancerId: '',
			listenerCount: 0,
			listenerProtocolType: "11",
			serverGroupId: '',// 默认为默认服务器组
			// 表单model
			ruleForm: {
				name: '',
				protocol: 'tcp',// 默认tcp
				port: '',
				algorithm: 'wrr',// 默认加权轮循
				stickySession: 'off',// 默认关闭
				stickySessionTimeout: '1000',
				cookieType: 'insert',
				http2: 'on',
				realIp: 'off',
				headers: [],
				domain: '',
				certificateId: '',
				healthCheck: 'on', // 默认开启
				healthCheckTimeout: '3', // 默认是3
				healthCheckInterval: '5', // 默认是3
				healthyThreshold: '3', // 默认是3
				unhealthyThreshold: '3', // 默认是3
				healthCheckUri: '/', // 默认是/
				healthCheckHttpCode: '2xx', // 默认是200
			},
			// 表单校验规则
			rules: {
				name: [
					{ validator: validateName, required: true, trigger: 'blur' }
				],
				protocol: [
					{ required: true }
				],
				port: [
					{ required: true, validator: validatePort, trigger: 'blur' }
				],
				domain: [
					{ required: true, validator: validateDomain, trigger: 'blur' }
				],
				certificateId: [
					{ required: true, validator: validateCertificateId, trigger: 'blur' }
				],
				stickySessionTimeout: [
					{ validator: validateStickySessionTimeout, trigger: 'blur' }
				],
				healthCheckTimeout: [
					{ required: true, validator: validateHealthCheckTimeout, trigger: 'blur' }
				],
				healthCheckInterval: [
					{ required: true, validator: validateHealthCheckInterval, trigger: 'blur' }
				],
				healthyThreshold: [
					{ required: true, validator: validateHealthyThreshold, trigger: 'blur' }
				],
				unhealthyThreshold: [
					{ required: true, validator: validateUnhealthyThreshold, trigger: 'blur' }
				],
				healthCheckUri: [
					{ required: true, validator: validateHealthCheckUri, trigger: 'blur' }
				],
				healthCheckHttpCode: [
					{ validator: validateHealthCheckHttpCode, trigger: 'blur' }
				]
			},
			// 表单各项是否符合校验
			ruleFormTag: {
				name: ValidOrErrorConstant.VALID,
				port: ValidOrErrorConstant.VALID,
				portPart1: ValidOrErrorConstant.VALID,
				portPart2: ValidOrErrorConstant.VALID,
				emptyDomain: ValidOrErrorConstant.VALID,
				errorDomain: ValidOrErrorConstant.VALID,
				certificateId: ValidOrErrorConstant.VALID,
				stickySessionTimeout: ValidOrErrorConstant.VALID,
				healthCheckTimeout: ValidOrErrorConstant.VALID,
				healthCheckTimeoutPart1: ValidOrErrorConstant.VALID,
				healthCheckTimeoutPart2: ValidOrErrorConstant.VALID,
				healthCheckInterval: ValidOrErrorConstant.VALID,
				healthCheckIntervalPart1: ValidOrErrorConstant.VALID,
				healthCheckIntervalPart2: ValidOrErrorConstant.VALID,
				healthyThreshold: ValidOrErrorConstant.VALID,
				unhealthyThreshold: ValidOrErrorConstant.VALID,
				healthCheckUri: ValidOrErrorConstant.VALID,
			},
			usefulRuleFormTag: {
				name: ValidOrErrorConstant.VALID,
				port: ValidOrErrorConstant.VALID,
				healthCheckTimeout: ValidOrErrorConstant.VALID,
				healthCheckInterval: ValidOrErrorConstant.VALID,
				healthyThreshold: ValidOrErrorConstant.VALID,
				unhealthyThreshold: ValidOrErrorConstant.VALID,
			},
			// 会话类型
			cookieTypes: [
				{
					label: this.$t('slb.text.setCookie'),
					value: 'insert'
				},
				{
					label: this.$t('slb.text.rewriteCookie'),
					value: 'rewrite'
				},
			],
			// 开启或关闭
			onOrOff: [
				{
					label: this.$t('slb.text.opened'),
					value: 'on'
				},
				{
					label: this.$t('slb.text.closed'),
					value: 'off'
				}
			],
			httpHeaders: [
				{
					label: 'X-Forwarded-For',
					value: 'X-Forwarded-For',
					tip: this.$t('slb.tooltip.httpHeaderForTip'),
				},
				{
					label: 'X-Forwarded-Proto',
					value: 'X-Forwarded-Proto',
					tip: this.$t('slb.tooltip.httpHeaderForProto'),
				},
				{
					label: 'X-Forwarded-Port',
					value: 'X-Forwarded-Port',
					tip: this.$t('slb.tooltip.httpHeaderForPort'),
				},
				{
					label: 'X-Forwarded-LBIP',
					value: 'X-Forwarded-LBIP',
					tip: this.$t('slb.tooltip.httpHeaderForLbip'),
				},
			],
			certificates: [],
			// 后端服务器组
			serverGroups: [
			],
			// 后端服务器列表
			backendServerListData: [],
			// 默认的健康检查IP
			defaultHealthCheckIp: '100.64.0.0/10',
			// 服务器列表加载状态
			listenerRefreshLoading: false,
			// 区分是创建还是修改
			type: 'create',
			// 临时存储编辑时的监听器数据
			listenerData: {},
			hasListenerDataLoaded: false,
			// 端口是否重复
			listenerPortRepeated: false
		};
	},
	mounted() {
		this.initQueries();
		this.initListenerData();
		this.getBackendServerGroupList();
	},
	watch: {
		// 端口
		'ruleForm.port': function (curVal) {
			if (!curVal) {
				this.ruleForm.port = ''
				return false
			}
			// 实时把非数字的输入过滤掉
			this.ruleForm.port = BM.filterNum(curVal);
		},
		// 响应超时时间
		'ruleForm.healthCheckTimeout': function (curVal) {
			if (!curVal) {
				this.ruleForm.healthCheckTimeout = ''
				return false
			}
			// 实时把非数字的输入过滤掉
			this.ruleForm.healthCheckTimeout = BM.filterNum(curVal);
		},
		// 健康检查间隔
		'ruleForm.healthCheckInterval': function (curVal) {
			if (!curVal) {
				this.ruleForm.healthCheckInterval = ''
				return false
			}
			// 实时把非数字的输入过滤掉
			this.ruleForm.healthCheckInterval = BM.filterNum(curVal);
		},
		// 健康阈值
		'ruleForm.healthyThreshold': function (curVal) {
			if (!curVal) {
				this.ruleForm.healthyThreshold = ''
				return false
			}
			// 实时把非数字的输入过滤掉
			this.ruleForm.healthyThreshold = BM.filterNum(curVal);
		},
		// 不健康阈值
		'ruleForm.unhealthyThreshold': function (curVal) {
			if (!curVal) {
				this.ruleForm.unhealthyThreshold = ''
				return false
			}
			// 实时把非数字的输入过滤掉
			this.ruleForm.unhealthyThreshold = BM.filterNum(curVal);
		},
	},
	computed: {
		ValidOrErrorConstant: () => ValidOrErrorConstant,
		BackendServerConstant: () => BackendServerConstant,
		ifCurrentProtocolUdp: function () {
			return this.ruleForm.protocol === ProtocolMapConstant['UDP']
		},
		ifCurrentProtocolHttp: function () {
			return this.ruleForm.protocol === ProtocolMapConstant['HTTP']
		},
		ifCurrentProtocolHttps: function () {
			return this.ruleForm.protocol === ProtocolMapConstant['HTTPS']
		},
		ifCurrentProtocol7Lb: function () {
			return this.ifCurrentProtocolHttps || this.ifCurrentProtocolHttp
		},
		ifStickySessionTimeout: function () {
			return this.ifCurrentProtocol7Lb && this.ruleForm.stickySession === 'on'
		},
		// 调度算法
		algorithms: function () {
			let protocol = this.ruleForm.protocol;
			let stickySession = this.ruleForm.stickySession;
			return this.getAlgorithms[protocol](stickySession);
		},
		// 基本配置必填项校验
		basicConfigValidateFailed: function () {
			return this.ruleFormTag.name === ValidOrErrorConstant.ERROR ||
				this.ruleFormTag.port === ValidOrErrorConstant.ERROR ||
				this.ruleFormTag.portPart1 === ValidOrErrorConstant.ERROR ||
				this.ruleFormTag.portPart2 === ValidOrErrorConstant.ERROR ||
				this.ruleFormTag.certificateId === ValidOrErrorConstant.ERROR ||
				this.listenerPortRepeated === true

		},
		// 健康检查必填项校验
		healthCheckValidateFailed: function () {
			return this.ruleFormTag.healthCheckTimeout === ValidOrErrorConstant.ERROR ||
				this.ruleFormTag.healthCheckTimeoutPart1 === ValidOrErrorConstant.ERROR ||
				this.ruleFormTag.healthCheckTimeoutPart2 === ValidOrErrorConstant.ERROR ||
				this.ruleFormTag.healthCheckInterval === ValidOrErrorConstant.ERROR ||
				this.ruleFormTag.healthCheckIntervalPart1 === ValidOrErrorConstant.ERROR ||
				this.ruleFormTag.healthCheckIntervalPart2 === ValidOrErrorConstant.ERROR ||
				this.ruleFormTag.healthyThreshold === ValidOrErrorConstant.ERROR ||
				this.ruleFormTag.unhealthyThreshold === ValidOrErrorConstant.ERROR ||
				this.ruleFormTag.healthCheckUri === ValidOrErrorConstant.ERROR
		},
		// 传参的时候一些固定的参数
		necessaryParams: function () {
			return {
				region: this.region,
				loadBalancerId: this.loadBalancerId,
				serverGroupId: this.serverGroupId,
				clientToken: this.clientToken
			}
		},
		// 健康检查是否开启
		isHealthCheckOn: function () {
			return this.ruleForm.healthCheck === 'on'
		},
		// 确定按钮是否置灰
		isConfirmDisabled: function () {
			return this.serverGroupId === ''
		},
		// 监听协议
		protocols: function () {

			let listenerProtocolType = this.listenerProtocolType;
			if (listenerProtocolType === "11") {
				return [
					{
						label: 'TCP',
						value: 'tcp'
					},
					{
						label: 'UDP',
						value: 'udp'
					},
					{
						label: 'HTTP',
						value: 'http'
					},
					{
						label: 'HTTPS',
						value: 'https'
					},
				]
			} else if (listenerProtocolType === "4") {
				return [
					{
						label: 'TCP',
						value: 'tcp'
					},
					{
						label: 'UDP',
						value: 'udp'
					}
				]
			} else if (listenerProtocolType === "7") {
				this.ruleForm.protocol = 'http';
				return [
					{
						label: 'HTTP',
						value: 'http'
					},
					{
						label: 'HTTPS',
						value: 'https'
					},
				]
			}
		},

	},
	methods: {
		focusPort() {
			this.ruleFormTag.port = ValidOrErrorConstant.VALID
			this.ruleFormTag.portPart1 = ValidOrErrorConstant.VALID
			this.ruleFormTag.portPart2 = ValidOrErrorConstant.VALID
			this.listenerPortRepeated = false
		},
		focusDomain() {
			this.ruleFormTag.domain = ValidOrErrorConstant.VALID
		},
		foucsStickySessionTimeout() {
			this.ruleFormTag.stickySessionTimeout = ValidOrErrorConstant.VALID
		},
		blurStickySessionTimeout() {
			console.log('blurStickySessionTimeout')
		},
		focusHealthCheckTimeout() {
			this.ruleFormTag.healthCheckTimeout = ValidOrErrorConstant.VALID
			this.ruleFormTag.healthCheckTimeoutPart1 = ValidOrErrorConstant.VALID
			this.ruleFormTag.healthCheckTimeoutPart2 = ValidOrErrorConstant.VALID
		},
		focusHealthCheckInterval() {
			this.ruleFormTag.healthCheckInterval = ValidOrErrorConstant.VALID
			this.ruleFormTag.healthCheckIntervalPart1 = ValidOrErrorConstant.VALID
			this.ruleFormTag.healthCheckIntervalPart2 = ValidOrErrorConstant.VALID
		},
		repairInputValue(event) {
			let stickySessionTimeout = this.ruleForm.stickySessionTimeout;
			if (!stickySessionTimeout) {
				this.ruleForm.stickySessionTimeout = '';
			}
			this.ruleForm.stickySessionTimeout = BM.filterNum(stickySessionTimeout);
		},
		// 模拟校验端口
		async validatePort(event) {
			let params = {
				region: this.region,
				loadBalancerId: this.loadBalancerId,
			}
			this.$refs.ruleForm.validateField('port')
			this.ruleFormTag.port = this.$refs.port.validateState
			if (this.ruleFormTag.port === ValidOrErrorConstant.VALID) {
				params = Object.assign(params, { port: event.target.value })
				const listenerPortRepeated = await Ajax.get('/api/cps/checkListenerPort', params)
					.then((res) => {
						console.log(res.data.success)
						return res.data.success
					})
					.catch(async (err) => {
						const { response } = err.data;
						try {
							const json = await response.json();
							// this.$message.error(json.errmsg);
						} catch (ex) {
							console.log(ex);
						}
					})
					.finally(() => { })
				this.listenerPortRepeated = listenerPortRepeated
			}
			let port = this.$refs['port'].$el;
			if (event.target.value > 65535 || event.target.value < 1
				|| this.listenerPortRepeated === true) {
				port.classList.add('is-error')
				if (event.target.value > 65535 || event.target.value < 1) {
					this.ruleFormTag.portPart1 = ValidOrErrorConstant.ERROR
				} else {
					this.ruleFormTag.portPart2 = ValidOrErrorConstant.ERROR
				}
			} else {
				port.classList.remove('is-error')
			}
		},
		// 模拟校验响应超时时间
		validateHealthCheckTimeout(event) {
			let healthCheckTimeout = this.$refs['healthCheckTimeout'].$el;
			if (event.target.value > 60 || event.target.value < 2
				|| event.target.value > parseInt(this.ruleForm.healthCheckInterval)) {
				healthCheckTimeout.classList.add('is-error')
				this.ruleFormTag.healthCheckTimeout = ValidOrErrorConstant.ERROR
				if (event.target.value > parseInt(this.ruleForm.healthCheckInterval)) {
					this.ruleFormTag.healthCheckTimeoutPart2 = ValidOrErrorConstant.ERROR
				} else {
					this.ruleFormTag.healthCheckTimeoutPart1 = ValidOrErrorConstant.ERROR
				}
			} else {
				healthCheckTimeout.classList.remove('is-error')
			}
		},
		// 模拟校验健康检查间隔
		validateHealthCheckInterval(event) {
			let healthCheckInterval = this.$refs['healthCheckInterval'].$el;
			if (event.target.value > 300 || event.target.value < 5
				|| event.target.value < parseInt(this.ruleForm.healthCheckTimeout)) {
				healthCheckInterval.classList.add('is-error')
				this.ruleFormTag.healthCheckInterval = ValidOrErrorConstant.ERROR
				if (event.target.value < parseInt(this.ruleForm.healthCheckTimeout)) {
					this.ruleFormTag.healthCheckIntervalPart2 = ValidOrErrorConstant.ERROR
				} else {
					this.ruleFormTag.healthCheckIntervalPart1 = ValidOrErrorConstant.ERROR
				}
			} else {
				healthCheckInterval.classList.remove('is-error')
			}
		},
		// 模拟校验健康阈值
		validateHealthyThreshold(event) {
			let healthCheckThreshold = this.$refs['healthyThreshold'].$el;
			if (event.target.value > 10 || event.target.value < 1) {
				healthCheckThreshold.classList.add('is-error')
				this.ruleFormTag.healthyThreshold = ValidOrErrorConstant.ERROR
			} else {
				healthCheckThreshold.classList.remove('is-error')
			}
		},
		// 模拟校验不健康阈值
		validateUnhealthyThreshold(event) {
			let unhealthyThreshold = this.$refs['unhealthyThreshold'].$el;
			if (event.target.value > 10 || event.target.value < 1) {
				unhealthyThreshold.classList.add('is-error')
				this.ruleFormTag.unhealthyThreshold = ValidOrErrorConstant.ERROR
			} else {
				unhealthyThreshold.classList.remove('is-error')
			}
		},
		// 跳转到SLB实例详情默认服务器组Tab
		jumpToSlbDetailDefaultServerGroupTab() {
			const targetRoute = this.$router.resolve({
				name: 'SlbDetail',
				query: {
					activeTabName: 'defaultServerGroup',
					region: this.region,
					loadBalancerId: this.loadBalancerId
				}
			});
			window.open(targetRoute.href, '_blank')
		},
		// 跳转到SLB实例详情监听器Tab
		jumpToSlbDetailListenerTab() {
			this.$router.push({
				name: 'SlbDetail',
				query: {
					activeTabName: 'listenerList',
					region: this.region,
					listenerId: this.listenerId,
					loadBalancerId: this.loadBalancerId
				}
			});
		},
		// 初始化从路由带过来的参数
		initQueries() {
			this.region = this.$route.query.region;
			this.type = this.$route.query.type;
			this.listenerId = this.$route.query.listenerId;
			this.loadBalancerId = this.$route.query.loadBalancerId;
			this.listenerCount = this.$route.query.listenerCount;
			this.listenerProtocolType = this.$route.query.listenerProtocolType || this.listenerProtocolType;
		},
		// 跳转到负载均衡想起-监听器Tab
		jumpToUp() {
			this.$router.push({
				name: 'SlbDetail',
				query: {
					activeTabName: 'listenerList',
					region: this.region,
					loadBalancerId: this.loadBalancerId
				}
			});
		},
		/**
		   **@disc: 确定按钮：根据不同的type：create/edit，调用不同的接口
		   **@params:
		*/
		async confirm() {
			let params = {
				region: this.region,
				loadBalancerId: this.loadBalancerId,
			}
			params = Object.assign(params, { port: this.ruleForm.port })
			const listenerPortRepeated = await Ajax.get('/api/cps/checkListenerPort', params)
				.then((res) => {
					console.log(res.data.success)
					return res.data.success
				})
				.catch(async (err) => {
					const { response } = err.data;
					try {
						const json = await response.json();
						// this.$message.error(json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
				})
				.finally(() => { })
			if (this.type === 'create') {
				this.listenerPortRepeated = listenerPortRepeated
			}
			this.$refs['ruleForm'].validate((valid) => {
				if (!valid) {
					for (let key in this.usefulRuleFormTag) {
						this.ruleFormTag[key] = this.$refs[key].validateState
					}
					if (this.basicConfigValidateFailed) {
						$(".mainCon").scrollTop($(".mainCon").scrollTop() + $('#baseConfig').offset().top - $(".mainCon").offset().top - 100);
						return false;
					}
					if (this.healthCheckValidateFailed) {
						$(".mainCon").scrollTop($(".mainCon").scrollTop() + $('#healthCheck').offset().top - $(".mainCon").offset().top - 100);
						return false;
					}
				} else {
					switch (this.type) {
						case 'create': {
							this.createListener();
							break;
						}
						case 'edit': {
							this.editListener();
							break;
						}
					}
				}
			});
		},
		/**
	   **@disc: 创建监听器
	   **@params:
		  */
		createListener() {
			const params = Object.assign(this.ruleForm, this.necessaryParams)
			Ajax.put('/api/cps/listeners', params, {
				headers: {
					'Content-Type': 'application/json'
				}
			})
				.then(() => {
					this.jumpToSlbDetailListenerTab();
				})
				.catch(async (err) => {
					const { response } = err.data;
					try {
						const json = await response.json();
						this.$message.error(json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
				})
				.finally(() => {
				})
		},
		/**
			**@disc: 修改监听器
			**@params:
		*/
		editListener() {
			const tempParams = Object.assign(this.necessaryParams, { listenerId: this.listenerId })
			let params = Object.assign(this.ruleForm, tempParams)
			// 过滤掉一些不存在的字段
			for (let itemKey in params) {
				if (!params[itemKey]) {
					params = _.omit(params, itemKey)
				}
			}
			Ajax.post('/api/cps/listeners', params, {
				headers: {
					'Content-Type': 'application/json'
				}
			})
				.then(() => {
					this.jumpToSlbDetailListenerTab();
				})
				.catch(async (err) => {
					const { response } = err.data;
					try {
						const json = await response.json();
						this.$message.error(json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
				})
				.finally(() => {
				})
		},
		/**
			**@disc: 如果类型为edit，调用获取监听器详情接口
			**@params:
		*/
		initListenerData() {
			if (this.type === 'edit') {
				const param = {
					region: this.region,
					listenerId: this.listenerId,
				}
				Ajax.get('/api/cps/listeners', param)
					.then((res) => {
						this.listenerData = res.data.listener;
						this.serverGroupId = this.listenerData.serverGroupId;
						this.hasListenerDataLoaded = true;
						for (let key in this.ruleForm) {
							if (key === 'protocol') {
								this.ruleForm[key] = res.data.listener[key].toLowerCase()
							} else {
								if (key === 'stickySession') {
									if (res.data.listener.stickySession === this.ruleForm.stickySession) {
										this.hasListenerDataLoaded = false;
									}
								}
								this.ruleForm[key] = res.data.listener[key] || this.ruleForm[key];
							}
						}
					})
					.catch(async (err) => {
						const { response } = err.data;
						try {
							const json = await response.json();
							this.$message.error(json.errmsg);
						} catch (ex) {
							console.log(ex);
						}
					})
					.finally(() => {
						this.listenerRefreshLoading = false
					})
				this.getCertificates(true);
			}
		},
		/**
		   **@disc: 获取后端服务器组列表
		   **@params:
		*/
		getBackendServerGroupList() {
			const param = {
				region: this.region,
				pageNumber: 1,
				pageSize: 200, // 最多200条
				loadBalancerId: this.loadBalancerId
			}
			Ajax.get('/api/cps/listServerGroups', param)
				.then((res) => {
					const serverGroups = res.data.serverGroups;
					this.serverGroups = serverGroups.map(item => {
						return {
							label: item.name,
							value: item.serverGroupId
						}
					});
					if (!this.serverGroups.length) {
						this.serverGroupId = '';
					}
				})
				.catch(async (err) => {
					const { response } = err.data;
					try {
						const json = await response.json();
						this.$message.error(json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
				})
				.finally(() => {
				})
		},

		getServerGroup(visible) {
			if (visible) {
				this.getBackendServerGroupList();
			}
		},
		/**
			**@disc: 修改协议
		*/
		changeProtocol(val) {
			if (this.type === 'edit') {
				if (this.listenerData.protocol === ProtocolMapConstant['TCP']) {
					if (val === ProtocolMapConstant['UDP']) {
						this.ruleForm.port = '';
					}
				} else if (this.listenerData.protocol === ProtocolMapConstant['UDP']) {
					if (val === ProtocolMapConstant['TCP']) {
						this.ruleForm.port = '80'
					}
				}
			} else if (this.type === 'create') {
				if (val === ProtocolMapConstant['UDP']) {
					this.ruleForm.port = '';
				} else if (val === ProtocolMapConstant['TCP']) {
					this.ruleForm.port = '80'
				}
			}
			if (this.type === 'create') {
				this.resetRealIp();
				this.resetAlgorithm();
			}
		},

		resetRealIp() {
			let protocol = this.ruleForm.protocol;
			if (protocol === 'https' || protocol === 'http') {
				this.ruleForm.realIp = 'on';
			} else {
				this.ruleForm.realIp = 'off';
			}
		},
		resetAlgorithm() {
			let stickySession = this.ruleForm.stickySession;
			if (this.ifCurrentProtocol7Lb) {
				this.ruleForm.algorithm = 'wrr'
			} else {
				if (stickySession === 'on') {
					this.ruleForm.algorithm = 'conhash'
				} else {
					this.ruleForm.algorithm = 'wrr'
				}
			}
		},
		/**
			**@disc: 会话保持改变
		*/
		changeStickySession(val) {
			if (!this.hasListenerDataLoaded) {
				this.resetAlgorithm();
			}
			this.hasListenerDataLoaded = false;
		},
		changeCertificate(val) {

		},
		getCertificates(visible) {
			if (visible) {
				const param = {
					region: this.region,
					pageNumber: 1,
					pageSize: 200,
				}
				Ajax.get('/api/cps/queryCertificatePage', param)
					.then((res) => {
						if (res.data.certs.length) {
							this.certificates = res.data.certs
						}
					})
					.catch(async (err) => {
						const { response } = err.data;
						try {
							const json = await response.json();
							this.$message.error(json.errmsg);
						} catch (ex) {
							console.log(ex);
						}
					})
					.finally(() => {
					})
			}
		},
		openCertificateCreate() {
			this.createCertVisible = true;
		},
		changeHealthCheck(val) {
			if (val === 'on') {
				this.ruleForm.healthCheckTimeout = '3';
				this.ruleForm.healthCheckInterval = '5';
				this.ruleForm.healthyThreshold = '3';
				this.ruleForm.unhealthyThreshold = '3';
				this.ruleForm.healthCheckUri = '/';
				this.ruleForm.healthCheckHttpCode = '2xx';
			}
		}
	}
};
</script>

<style lang="scss">
@import '~@/assets/scss/createCommon';
@import '~@/assets/scss/sliderCommon';
@import 'style';
</style>



// WEBPACK FOOTER //
// src/views/slb/detail/listener/edit/Edit.vue